import React from 'react';
import { connect } from 'react-redux';
import Tracker from '../../../../genesys/tracker';
import { WIDGET_ACTIONS } from '../../../layers/widget/types';
import IPC from '../../../../helpers/ipc';
import CMBForm from '../../cmb/modes/maximized';
import { CMB_MODE } from '../../cmb/types';
import * as CMBActions from '../../cmb/actions';
import * as Conditions from '../../../layers/widget/conditions';
import Literal from '../../../controls/literal';

class F_5 extends React.Component {
    constructor(props) {
        super(props);

        this.state = { disabled: false, started: false, cmb: false };

        this.gotoNextStep = this.gotoNextStep.bind(this);
    }

    componentDidMount() {
        if (!this.state.started) {
            Tracker.sendEvent('mobileCallStart', {
                ...this.props.userdata,
                engagementId: this.props.engagementId,
                category: this.props.call.registration.categoryId
            });
            this.setState({ started: true });
        }
        if (
            this.props.call.registration.login_type === 'offer' ||
            this.props.call.registration.categoryCMB
        ) {
            if (this.props.cmbConfig.cmbImmediateAvailable) {
                CMBActions.saveMode(CMB_MODE.IMMEDIATE);
                this.setState({ cmb: true });
            } else if (this.props.cmbConfig.cmbDelayedAvailable) {
                CMBActions.saveMode(CMB_MODE.DELAYED);
                this.setState({ cmb: true });
            }
            let phoneNumber =
                this.props.call.registration.userIdentificationNumber ||
                this.props.call.registration.msisdn ||
                this.props.call.registration.product_number;
            if (phoneNumber && phoneNumber.length === 9) {
                CMBActions.savePhone(phoneNumber, true);
                CMBActions.saveValidationState(true);
            }
        }
    }

    gotoNextStep(e) {
        if (e) {
            e.preventDefault();
        }

        this.setState({ disabled: true });

        const target = e ? e.target : null;
        if (target && !target.dataset['reason']) {
            IPC.sendEvent(
                WIDGET_ACTIONS.CALL,
                this.props.config.token && this.props.config.token.length > 0
                    ? `${this.props.call.registration.categoryTel},${this.props.config.token}`
                    : this.props.call.registration.categoryTel
            );
        }

        setTimeout(() => {
            this.props.nextStep(null, target ? target.dataset['reason'] || null : 'Cancel');
        }, 500);
    }

    render() {
        const { cmbConfig, cmbUserData } = this.props;
        if (this.props.call.registration.categoryOffline) {
            return (
                <div className="click2call--groups">
                    <div className="click2call--group click2call--group-label">
                        <p className="click2call--content-offline">
                            <Literal
                                static={this.props.call.registration.categoryOfflineDescription}
                                default="Dziś już nie pracujemy. Spróbuj ponownie innego dnia."
                            />
                        </p>
                    </div>
                </div>
            );
        }

        return (
            <div className="click2call--groups">
                <div className="click2call--group click2call--group-label">
                    <p>Połączenie płatne zgodnie z cennikiem. Kontynuować?</p>
                </div>
                <div className="click2call--group">
                    <div className="click2call--content-choice">
                        <button
                            className="cancel"
                            onClick={this.gotoNextStep}
                            data-reason="Cancel"
                            disabled={this.state.disabled}
                        >
                            Rezygnuję
                        </button>
                        <button
                            className="accept"
                            onClick={this.gotoNextStep}
                            disabled={this.state.disabled}
                        >
                            Połącz z doradcą
                        </button>
                    </div>
                </div>
                {this.state.cmb &&
                    Conditions.isCMBAvailable(this.props.state) && (
                    <div className="click2call--group click2call--group-expand">
                        <div className="click2call--content-label">
                            <p>Lub</p>
                        </div>
                        <CMBForm
                            config={cmbConfig}
                            cmbUserData={cmbUserData}
                            events={{ close: () => this.gotoNextStep() }}
                            title={
                                <p>
                                        Oddzwonimy do Ciebie za darmo w{' '}
                                    <strong>
                                        {this.props.cmbConfig.cmbImmediateCountdown || 10}{' '}
                                            sekund
                                    </strong>.
                                </p>
                            }
                            buttonTitle="Zamawiam rozmowę"
                            scheduledTitle="Lub zamów rozmów na inny termin"
                            icon="info"
                            spinner={false}
                            newStyle={true}
                            isMobile={true}
                        />
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        call: state.call,
        main: state.main,
        engagementId: state.config.widget.engagementId,
        config: state.config.widget.callOptions,
        cmbConfig: state.config.widget.cmbOptions,
        cmbUserData: state.config.widget.cmbUserData,
        userdata: state.config.widget.callUserData || {},
        state: state
    };
};

export default connect(mapStateToProps)(F_5);
